import { cacheKeys as maxCacheLength } from 'constants/CalendarState';

interface ComputeSavedEntityStateOptions<StateToSave> {
  todayString: string;
  newDate: string;
  stateToSave: StateToSave;
  savedState: Dictionary<StateToSave>;
}

export function computeSavedEntityState<StateToSave>({
  todayString,
  newDate,
  savedState,
  stateToSave,
}: ComputeSavedEntityStateOptions<StateToSave>) {
  const newSavedState: Dictionary<StateToSave> = {
    ...savedState,
  };

  if (Object.keys(savedState).length === maxCacheLength) {
    const keysWithoutToday = Object.keys(savedState).filter((key) => key !== todayString);
    if (keysWithoutToday.length === maxCacheLength - 1 && newDate !== todayString) {
      const keyToRemove = keysWithoutToday.slice(0, 1)[0];
      delete newSavedState[keyToRemove];
    }
    newSavedState[newDate] = stateToSave;
  } else {
    newSavedState[newDate] = stateToSave;
  }
  return newSavedState;
}
